// extracted by mini-css-extract-plugin
export default {"wrapper":"BackToTop_wrapper__OQsgq","icon":"BackToTop_icon__MXO-x"};